import {
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../constants";
import { toast } from "react-toastify";
import AccountCreateDialog from "../components/ManualVouchers/AccountCreateDialog";
import SaveIcon from "@mui/icons-material/Save";
import BillAdjustment from "../components/ManualVouchers/BillAdjustment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";

const ManualVouchers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const voucherGroupId = location?.state?.voucherGroupId || null;
  console.log("voucherGroupId: ", voucherGroupId);
  const typeRef = useRef(null);
  const dateRef = useRef(null);
  const rowRefs = useRef([]);
  const saveBtnRef = useRef(null);
  const [openAccountDialog, setOpenAccountDialog] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  const [isBalanced, setIsBalanced] = useState(false);

  const debounceRef = useRef();
  const narrationRef = useRef(null);
  const [activeCell, setActiveCell] = useState({
    row: null,
    field: null,
  });

  const [voucherType, setVoucherType] = useState("Receipt");
  const [voucherDate, setVoucherDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [narration, setNarration] = useState("");

  const [rows, setRows] = useState(
    Array.from({ length: 1 }, () => ({
      account: null,
      balance: 0,
      debit: "",
      credit: "",
      type: "", // 🔥 NEW
    })),
  );

  const fetchVoucherGroup = async () => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}api/user/common/voucher/${voucherGroupId}`,
        {
          headers: {},
        },
      );
      console.log(data);
      if (data?.vouchers?.length) {
        setRows(
          data.vouchers.map((voucher) => {
            return {
              account: voucher?.accountId?.name || "",
              accountId: voucher?.accountId?._id || "",
              balance: voucher?.balance || 0,
              debit: voucher.debitAmount || "",
              credit: voucher.creditAmount || "",
              type:
                voucher.debitAmount > 0
                  ? "Dr"
                  : voucher.creditAmount > 0
                    ? "Cr"
                    : "",
            };
          }),
        );
        setVoucherType(data.vouchers[0]?.voucherType);
        setNarration(data.vouchers[0]?.narration);
      } else {
        setRows([
          {
            account: null,
            balance: 0,
            debit: "",
            credit: "",
            type: "",
          },
        ]);
        setNarration("");
        setVoucherType("");
      }
    } catch (error) {
      console.error("Error fetching voucher group:", error);
    }
  };

  useEffect(() => {
    if (!voucherGroupId) return;
    fetchVoucherGroup();
  }, [voucherGroupId]);

  console.log("rows: ", rows);

  const [openBillAdjustment, setOpenBillAdjustment] = useState(false);
  const [billRowIndex, setBillRowIndex] = useState(null);

  const fetchAccounts = async (search = "") => {
    if (!search) return setAccountOptions([]);

    setAccountLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}api/user/common/accounts/search?q=${search}`,
        {
          headers: {},
        },
      );

      const data = await res.json();
      if (data.success) setAccountOptions(data.accounts || []);
    } catch {
      toast.error("Error fetching accounts");
    } finally {
      setAccountLoading(false);
    }
  };

  const [groups, setGroups] = useState([]);
  useEffect(() => {
    const fetchAllGroups = async () => {
      try {
        const res = await fetch(`${BASE_URL}api/user/common/groups/all`, {
          headers: {},
        });

        const data = await res.json();

        if (data.success) {
          setGroups(data.groups);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchAllGroups();
  }, []);

  const totalDebit = rows.reduce((sum, r) => sum + Number(r.debit || 0), 0);
  const totalCredit = rows.reduce((sum, r) => sum + Number(r.credit || 0), 0);

  useEffect(() => {
    const balanced = totalDebit === totalCredit && totalDebit > 0;
    setIsBalanced(balanced);
  }, [totalDebit, totalCredit]);

  const enhancedOptions = [
    { name: "F2 → Create New", isCreate: true },
    ...(accountOptions.length
      ? accountOptions
      : [{ name: "No results", disabled: true }]),
  ];

  const handleAccountInputChange = (value) => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchAccounts(value), 400);
  };

  useEffect(() => {
    setTimeout(() => {
      typeRef.current?.focus();
    }, 200);
  }, []);

  const moveToNextRow = (index) => {
    const nextIndex = index + 1;

    if (!rows[nextIndex]) {
      setRows((prev) => [
        ...prev,
        { account: "", balance: 0, debit: "", credit: "", type: "" },
      ]);

      setTimeout(() => {
        rowRefs.current[nextIndex]?.drcr?.focus();
      }, 0);

      return;
    }

    setTimeout(() => {
      rowRefs.current[nextIndex]?.drcr?.focus();
    }, 0);
  };

  // useEffect(() => {
  //   const handleF5 = (e) => {
  //     if (e.key === "F5") {
  //       e.preventDefault();

  //       if (totalDebit !== totalCredit) {
  //         toast.error("Debit and Credit must be equal");
  //         return;
  //       }

  //       toast.success("Balanced ✔");

  //       setTimeout(() => {
  //         narrationRef.current?.focus();
  //       }, 100);
  //     }
  //   };

  //   window.addEventListener("keydown", handleF5);
  //   return () => window.removeEventListener("keydown", handleF5);
  // }, [rows]);

  const focusCell = (rowIndex, field) => {
    const row = rowRefs.current[rowIndex];
    if (!row) return;

    setTimeout(() => {
      row[field]?.focus();
    }, 50);
  };

  const handleArrowNavigation = (e, rowIndex, field) => {
    const key = e.key;

    const fieldOrder = ["drcr", "account", "debit", "credit"];
    const colIndex = fieldOrder.indexOf(field);

    // ⬇️ DOWN
    if (key === "ArrowDown") {
      if (autocompleteOpen) return;

      e.preventDefault();
      focusCell(rowIndex + 1, field);
    }

    // ⬆️ UP
    if (key === "ArrowUp") {
      if (autocompleteOpen) return;

      e.preventDefault();
      if (rowIndex > 0) {
        focusCell(rowIndex - 1, field);
      }
    }

    // ➡️ RIGHT
    if (key === "ArrowRight") {
      e.preventDefault();

      // 🔥 SPECIAL CASE: account → debit/credit
      if (field === "account") {
        if (rows[rowIndex]?.type === "Dr") {
          focusCell(rowIndex, "debit");
        } else if (rows[rowIndex]?.type === "Cr") {
          focusCell(rowIndex, "credit");
        }
        return;
      }

      // normal flow
      if (colIndex < fieldOrder.length - 1) {
        focusCell(rowIndex, fieldOrder[colIndex + 1]);
      }
    }

    // ⬅️ LEFT
    if (key === "ArrowLeft") {
      e.preventDefault();

      // 🔥 SPECIAL CASE: from debit/credit → go to account
      if (field === "debit" || field === "credit") {
        focusCell(rowIndex, "account");
        return;
      }

      // normal fallback
      if (colIndex > 0) {
        focusCell(rowIndex, fieldOrder[colIndex - 1]);
      }
    }
  };

  const deleteRow = (index) => {
    if (rows.length === 1) return;

    const updated = rows.filter((_, i) => i !== index);

    const nextIndex = index < updated.length ? index : updated.length - 1;

    setRows(updated);

    // 🔥 WAIT FOR RE-RENDER THEN FOCUS
    setTimeout(() => {
      const nextRow = rowRefs.current[nextIndex];

      if (!nextRow) return;

      // focus intelligently
      if (updated[nextIndex]?.type === "Dr") {
        nextRow.debit?.focus();
      } else if (updated[nextIndex]?.type === "Cr") {
        nextRow.credit?.focus();
      } else {
        nextRow.drcr?.focus();
      }
    }, 0); // 🔥 IMPORTANT: 0ms, not 150
  };

  const handleDeleteShortcut = (e, index) => {
    if (e.shiftKey && (e.key === "Backspace" || e.key === "Delete")) {
      e.preventDefault();
      deleteRow(index);
    }
  };

  useEffect(() => {
    const handleF2 = (e) => {
      if (e.key === "F2") {
        e.preventDefault();

        // 🔥 use current active row
        setOpenAccountDialog(true);
      }
    };

    window.addEventListener("keydown", handleF2);
    return () => window.removeEventListener("keydown", handleF2);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") {
        e.preventDefault();

        // 🔥 Force blur so last value commits
        const active = document.activeElement;
        if (active && typeof active.blur === "function") {
          active.blur();
        }

        // 🔥 Trigger actual button click
        setTimeout(() => {
          saveBtnRef.current?.click();
        }, 50);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleAccountCreated = (account) => {
    if (activeRowIndex === null) return;

    const updated = [...rows];

    updated[activeRowIndex].account = account.name;
    updated[activeRowIndex].accountId = account._id;
    updated[activeRowIndex].balance = account.balance || 0;

    setRows(updated);

    // 🔥 focus next field
    setTimeout(() => {
      const rowRef = rowRefs.current[activeRowIndex];
      if (!rowRef) return;

      if (updated[activeRowIndex].type === "Dr") {
        rowRef.debit?.focus();
      } else if (updated[activeRowIndex].type === "Cr") {
        rowRef.credit?.focus();
      } else {
        rowRef.drcr?.focus();
      }
    }, 100);
  };

  const handleSaveVoucher = async () => {
    // 🔥 VALIDATION
    if (totalDebit !== totalCredit) {
      toast.error("Debit and Credit must be equal");
      return;
    }

    const cleanRows = rows
      .filter((r) => r.accountId && (r.debit || r.credit))
      .map((r) => ({
        accountId: r.accountId,
        type: r.type,
        debit: Number(r.debit || 0),
        credit: Number(r.credit || 0),
        billAllocation: r.billAllocation || [],
      }));

    if (cleanRows.length === 0) {
      toast.error("No valid entries");
      return;
    }

    const payload = {
      voucherType,
      voucherDate,
      narration,
      entries: cleanRows,
      totalDebit,
      totalCredit,
    };

    try {
      const res = await fetch(`${BASE_URL}api/user/accounting/save-vouchers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!data.success) {
        toast.error(data.message || "Failed to save voucher");
        return;
      }
      alert("Voucher saved successfully ✔");
      window.location.reload();
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  const handleUpdateVoucher = async () => {
    // 🔥 VALIDATION
    if (totalDebit !== totalCredit) {
      toast.error("Debit and Credit must be equal");
      return;
    }

    const cleanRows = rows
      .filter((r) => r.accountId && (r.debit || r.credit))
      .map((r) => ({
        accountId: r.accountId,
        type: r.type,
        debit: Number(r.debit || 0),
        credit: Number(r.credit || 0),
        billAllocation: r.billAllocation || [],
      }));

    if (cleanRows.length === 0) {
      toast.error("No valid entries");
      return;
    }

    const payload = {
      voucherGroupId,
      voucherType,
      voucherDate,
      narration,
      entries: cleanRows,
      totalDebit,
      totalCredit,
    };

    try {
      const res = await fetch(
        `${BASE_URL}api/user/accounting/update-vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (!data.success) {
        toast.error(data.message || "Failed to update voucher");
        return;
      }
      toast.success("Voucher updated successfully ✔");
      handleCancel();
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  const [tableKey, setTableKey] = useState(0);
  const handleCancel = () => {
    navigate(location.pathname, {
      replace: true,
      state: null,
    });

    setRows([
      {
        account: null,
        accountId: "",
        balance: 0,
        debit: "",
        credit: "",
        type: "",
        billAllocation: [],
      },
    ]);

    setNarration("");
    setVoucherType("");

    // Force all rows/Autocomplete to remount
    setTableKey((prev) => prev + 1);
  };

  return (
    <Box>
      <Box
        sx={{
          mb: 2,
          p: 2,
          background: "#ffffff",
          borderRadius: "14px",
          border: "1px solid #e5e9ef",
          boxShadow: "0 2px 8px rgba(10,31,68,0.06)",
          display: "flex",
          flexDirection: "column", // 🔥 KEY CHANGE
          gap: 1.5,
        }}
      >
        {/* 🔥 HEADER (TOP) */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "8px",
              background: "linear-gradient(135deg, #2a54a6, #b93acf)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 3px 8px rgba(185,58,207,0.25)",
            }}
          >
            <ReceiptLongIcon sx={{ color: "#fff", fontSize: "0.95rem" }} />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 700,
                  color: "#0a1f44",
                  lineHeight: 1.2,
                }}
              >
                {voucherGroupId ? "Update Voucher" : "New Voucher"}
              </Typography>

              <Typography sx={{ fontSize: "0.65rem", color: "#94a3b8" }}>
                Press Enter to move between fields
              </Typography>
            </Box>
            {voucherGroupId && (
              <Button
                variant="outlined"
                onClick={handleCancel}
                sx={{
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 2.5,
                  py: 0.8,
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  color: "#dc2626",
                  borderColor: "rgba(239,68,68,0.2)",
                  background: "rgba(239,68,68,0.06)",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.08)",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    background: "rgba(239,68,68,0.12)",
                    borderColor: "rgba(239,68,68,0.35)",
                    transform: "translateY(-1px)",
                    boxShadow: "0 6px 14px rgba(239,68,68,0.15)",
                  },
                }}
              >
                Cancel
              </Button>
            )}
          </Box>
        </Box>

        {/* 🔥 DIVIDER */}
        <Box
          sx={{
            height: "1px",
            width: "100%",
            background: "#e5e9ef",
          }}
        />

        {/* 🔥 FORM ROW (BOTTOM) */}
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            alignItems: "flex-end",
            flexWrap: "wrap",
          }}
        >
          {/* Voucher Type */}
          <Box sx={{ flex: 1, minWidth: 140 }}>
            <Typography sx={vLabelStyle}>Voucher Type</Typography>
            <TextField
              select
              value={voucherType}
              inputRef={typeRef}
              onChange={(e) => setVoucherType(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  dateRef.current?.focus();
                }
              }}
              SelectProps={{ native: true }}
              fullWidth
              size="small"
              sx={vFieldStyle}
            >
              {[
                "Receipt",
                "Sale",
                "Purchase",
                "Payment",
                "Journal",
                "Contra",
              ].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </TextField>
          </Box>

          {/* Date */}
          <Box sx={{ flex: 1, minWidth: 160 }}>
            <Typography sx={vLabelStyle}>Date</Typography>
            <TextField
              type="date"
              inputRef={dateRef}
              InputLabelProps={{ shrink: true }}
              value={voucherDate}
              onChange={(e) => setVoucherDate(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setTimeout(() => rowRefs.current[0]?.drcr?.focus(), 100);
                }
              }}
              fullWidth
              size="small"
              sx={vFieldStyle}
            />
          </Box>

          {/* Voucher Type Pill */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              px: 1.5,
              py: 0.6,
              borderRadius: "100px",
              background:
                "linear-gradient(135deg, rgba(42,84,166,0.08), rgba(185,58,207,0.06))",
              border: "1px solid rgba(185,58,207,0.2)",
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "linear-gradient(135deg,#2a54a6,#b93acf)",
              }}
            />
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 700,
                background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {voucherType}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          background: "#ffffff",
          border: "1px solid #e5e9ef",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
          maxHeight: "320px",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "3px" },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(185,58,207,0.25)",
            borderRadius: "4px",
          },
        }}
      >
        <Table size="small" stickyHeader sx={{ tableLayout: "fixed" }}>
          {/* ── Head ── */}
          <TableHead>
            <TableRow>
              {[
                { label: "Dr/Cr", width: "8%", align: "center" },
                { label: "Account", width: "42%", align: "left" },
                { label: "Balance", width: "16%", align: "right" },
                { label: "Debit", width: "17%", align: "right" },
                { label: "Credit", width: "17%", align: "right" },
              ].map((col) => (
                <TableCell
                  key={col.label}
                  align={col.align}
                  sx={{
                    width: col.width,
                    background: "linear-gradient(135deg, #0a1f44, #1a3568)",
                    fontSize: "0.62rem",
                    fontWeight: 700,
                    color: "rgba(255,255,255,0.85)",
                    textTransform: "uppercase",
                    letterSpacing: "0.6px",
                    py: "10px",
                    px: "10px",
                    borderBottom: "none",
                    "&:first-of-type": { borderRadius: "0" },
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* ── Body ── */}
          <TableBody key={tableKey}>
            {rows.map((row, index) => {
              const isActive = activeRowIndex === index;
              return (
                <TableRow
                  key={`${tableKey}-${index}`}
                  sx={{
                    background: isActive
                      ? "linear-gradient(135deg, rgba(42,84,166,0.06), rgba(185,58,207,0.04))"
                      : index % 2 === 0
                        ? "#ffffff"
                        : "#fafbfc",
                    borderLeft: isActive
                      ? "2.5px solid #b93acf"
                      : "2.5px solid transparent",
                    transition: "all 0.15s ease",
                    "&:hover": { background: "rgba(42,84,166,0.03)" },
                    "& .MuiTableCell-root": {
                      py: "5px",
                      px: "8px",
                      borderBottom: "1px solid #f1f5f9",
                    },
                    "&:last-child .MuiTableCell-root": { borderBottom: 0 },
                  }}
                >
                  {/* ── Dr/Cr pill ── */}
                  <TableCell align="center" sx={{ width: "8%" }}>
                    <TextField
                      size="small"
                      value={row.type || ""}
                      inputRef={(el) => {
                        if (!rowRefs.current[index])
                          rowRefs.current[index] = {};
                        rowRefs.current[index].drcr = el;
                      }}
                      onFocus={() => {
                        setActiveRowIndex(index);
                        setActiveCell({ row: index, field: "drcr" });
                      }}
                      onChange={() => {}}
                      onKeyDown={(e) => {
                        handleDeleteShortcut(e, index);
                        handleArrowNavigation(e, index, "drcr");
                        if (e.key === "Enter") {
                          if (!row.type) return;
                          e.preventDefault();
                          setTimeout(
                            () => rowRefs.current[index]?.account?.focus(),
                            50,
                          );
                          return;
                        }
                        if (e.key.toLowerCase() === "d") {
                          e.preventDefault();
                          const u = [...rows];
                          u[index].type = "Dr";
                          u[index].credit = "";
                          setRows(u);
                          setTimeout(
                            () => rowRefs.current[index]?.account?.focus(),
                            50,
                          );
                        }
                        if (e.key.toLowerCase() === "c") {
                          e.preventDefault();
                          const u = [...rows];
                          u[index].type = "Cr";
                          u[index].debit = "";
                          setRows(u);
                          setTimeout(
                            () => rowRefs.current[index]?.account?.focus(),
                            50,
                          );
                        }
                      }}
                      sx={{
                        width: 48,
                        "& .MuiOutlinedInput-root": {
                          height: 30,
                          borderRadius: "8px",
                          fontSize: "0.72rem",
                          fontWeight: 800,
                          background:
                            row.type === "Dr"
                              ? "rgba(16,185,129,0.1)"
                              : row.type === "Cr"
                                ? "rgba(239,68,68,0.08)"
                                : "#f8fafc",
                          color:
                            row.type === "Dr"
                              ? "#059669"
                              : row.type === "Cr"
                                ? "#dc2626"
                                : "#94a3b8",
                          border: "1.5px solid",
                          borderColor:
                            row.type === "Dr"
                              ? "rgba(16,185,129,0.3)"
                              : row.type === "Cr"
                                ? "rgba(239,68,68,0.25)"
                                : "#e5e9ef",
                          "& fieldset": { border: "none" },
                          "& input": {
                            textAlign: "center",
                            padding: "4px 2px",
                            fontWeight: 800,
                          },
                          transition: "all 0.2s ease",
                        },
                      }}
                    />
                  </TableCell>

                  {/* ── Account + Autocomplete ── */}
                  <TableCell sx={{ width: "42%" }}>
                    <Box
                      sx={{ display: "flex", gap: 0.75, alignItems: "center" }}
                    >
                      <Autocomplete
                        freeSolo
                        fullWidth
                        autoHighlight
                        onOpen={() => setAutocompleteOpen(true)}
                        onClose={() => setAutocompleteOpen(false)}
                        getOptionDisabled={(option) => option.isCreate}
                        isOptionEqualToValue={(opt, val) =>
                          opt.name === val.name
                        }
                        options={enhancedOptions}
                        filterOptions={(options, state) => {
                          const input = state.inputValue.toLowerCase();
                          return options.filter(
                            (opt) =>
                              opt.isCreate ||
                              opt.disabled ||
                              opt.name.toLowerCase().includes(input),
                          );
                        }}
                        getOptionLabel={(option) => option?.name || ""}
                        loading={accountLoading}
                        value={
                          row.account
                            ? { name: row.account, balance: row.balance }
                            : null
                        }
                        onInputChange={(e, value) => {
                          const u = [...rows];
                          u[index].account = value;
                          setRows(u);
                          handleAccountInputChange(value);
                          setActiveRowIndex(index);
                        }}
                        onChange={(e, value) => {
                          if (!value) return;
                          if (value.isCreate) {
                            e.preventDefault();
                            setActiveRowIndex(index);
                            setOpenAccountDialog(true);
                            return;
                          }
                          const u = [...rows];
                          u[index].account = value.name;
                          u[index].accountId = value._id;
                          u[index].balance = value.balance || 0;
                          setRows(u);
                          setTimeout(() => {
                            const r = rowRefs.current[index];
                            if (!r) return;
                            if (u[index].type === "Dr") r.debit?.focus();
                            else if (u[index].type === "Cr") r.credit?.focus();
                            else r.drcr?.focus();
                          }, 200);
                        }}
                        renderOption={(props, option) => {
                          if (option.isCreate) {
                            return (
                              <Box
                                component="li"
                                {...props}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setActiveRowIndex(index);
                                  setOpenAccountDialog(true);
                                }}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  px: 1.5,
                                  py: 1,
                                  background:
                                    "linear-gradient(135deg,rgba(42,84,166,0.06),rgba(185,58,207,0.04))",
                                  borderBottom: "1px solid #e5e9ef",
                                  cursor: "pointer",
                                  "&:hover": {
                                    background:
                                      "linear-gradient(135deg,rgba(42,84,166,0.1),rgba(185,58,207,0.08))",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    borderRadius: "5px",
                                    background:
                                      "linear-gradient(135deg,#2a54a6,#b93acf)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  <AddIcon
                                    sx={{ color: "#fff", fontSize: "0.7rem" }}
                                  />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "0.8rem",
                                    fontWeight: 700,
                                    background:
                                      "linear-gradient(135deg,#2a54a6,#b93acf)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    backgroundClip: "text",
                                  }}
                                >
                                  {option.name}
                                </Typography>
                              </Box>
                            );
                          }
                          return (
                            <Box
                              component="li"
                              {...props}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                px: 1.5,
                                py: "8px",
                                borderBottom: "1px solid #f1f5f9",
                                gap: 1,
                                "&:hover": {
                                  background: "rgba(42,84,166,0.03)",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  flex: 1,
                                  fontSize: "0.83rem",
                                  color: "#0a1f44",
                                  fontWeight: 500,
                                }}
                              >
                                {option.name}
                              </Typography>
                              <Box
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  background:
                                    option.balance >= 0
                                      ? "rgba(16,185,129,0.08)"
                                      : "rgba(239,68,68,0.07)",
                                  border: `1px solid ${option.balance >= 0 ? "rgba(16,185,129,0.2)" : "rgba(239,68,68,0.2)"}`,
                                  borderRadius: "100px",
                                  px: "8px",
                                  py: "1px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "0.7rem",
                                    fontWeight: 700,
                                    color:
                                      option.balance >= 0
                                        ? "#059669"
                                        : "#dc2626",
                                    fontFamily: "monospace",
                                  }}
                                >
                                  ₹
                                  {Math.abs(
                                    option.balance || 0,
                                  ).toLocaleString()}{" "}
                                  {option.balance >= 0 ? "Dr" : "Cr"}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            placeholder="Account name…"
                            inputRef={(el) => {
                              if (!rowRefs.current[index])
                                rowRefs.current[index] = {};
                              rowRefs.current[index].account = el;
                            }}
                            onFocus={() => {
                              setActiveRowIndex(index);
                              setActiveCell({ row: index, field: "account" });
                            }}
                            onKeyDown={(e) => {
                              handleDeleteShortcut(e, index);
                              handleArrowNavigation(e, index, "account");
                              if (e.key === "Enter") {
                                const first = enhancedOptions.find(
                                  (opt) => !opt.isCreate && !opt.disabled,
                                );
                                if (!first) return;
                                e.preventDefault();
                                const u = [...rows];
                                u[index].account = first.name;
                                u[index].balance = first.balance || 0;
                                setRows(u);
                                setTimeout(() => {
                                  const r = rowRefs.current[index];
                                  if (!r) return;
                                  if (u[index].type === "Dr") r.debit?.focus();
                                  else if (u[index].type === "Cr")
                                    r.credit?.focus();
                                }, 200);
                              }
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                fontSize: "0.83rem",
                                background:
                                  activeCell.row === index &&
                                  activeCell.field === "account"
                                    ? "linear-gradient(135deg,rgba(42,84,166,0.06),rgba(185,58,207,0.04))"
                                    : "#f8fafc",
                                "& fieldset": { borderColor: "#e5e9ef" },
                                "&:hover fieldset": { borderColor: "#2a54a6" },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#b93acf",
                                  borderWidth: "1.5px",
                                },
                              },
                            }}
                          />
                        )}
                      />

                      {/* Allocated badge */}
                      {row.billAllocation?.length > 0 && (
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.5,
                            flexShrink: 0,
                            background: "rgba(16,185,129,0.1)",
                            border: "1px solid rgba(16,185,129,0.25)",
                            borderRadius: "6px",
                            px: "7px",
                            py: "2px",
                          }}
                        >
                          <CheckCircleIcon
                            sx={{ fontSize: "0.7rem", color: "#059669" }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.65rem",
                              fontWeight: 700,
                              color: "#059669",
                            }}
                          >
                            Allocated
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </TableCell>

                  {/* ── Balance ── */}
                  <TableCell align="right" sx={{ width: "16%" }}>
                    {row.balance ? (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          background:
                            row.balance >= 0
                              ? "rgba(16,185,129,0.08)"
                              : "rgba(239,68,68,0.07)",
                          border: `1px solid ${row.balance >= 0 ? "rgba(16,185,129,0.2)" : "rgba(239,68,68,0.2)"}`,
                          borderRadius: "100px",
                          px: "8px",
                          py: "1px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.68rem",
                            fontWeight: 700,
                            color: row.balance >= 0 ? "#059669" : "#dc2626",
                            fontFamily: "monospace",
                          }}
                        >
                          ₹{Math.abs(row.balance).toLocaleString()}{" "}
                          {row.balance >= 0 ? "Dr" : "Cr"}
                        </Typography>
                      </Box>
                    ) : null}
                  </TableCell>

                  {/* ── Debit ── */}
                  <TableCell align="right" sx={{ width: "17%" }}>
                    <TextField
                      size="small"
                      fullWidth
                      disabled={row.type !== "Dr"}
                      value={row.debit}
                      inputRef={(el) => {
                        if (!rowRefs.current[index])
                          rowRefs.current[index] = {};
                        rowRefs.current[index].debit = el;
                      }}
                      inputProps={{
                        style: {
                          textAlign: "right",
                          fontFamily: "monospace",
                          fontWeight: 600,
                        },
                      }}
                      onFocus={() => {
                        setActiveRowIndex(index);
                        setActiveCell({ row: index, field: "debit" });
                      }}
                      onChange={(e) => {
                        const u = [...rows];
                        u[index].debit = e.target.value;
                        u[index].credit = "";
                        setRows(u);
                      }}
                      onKeyDown={(e) => {
                        handleDeleteShortcut(e, index);
                        handleArrowNavigation(e, index, "debit");
                        if (e.key === "Enter") {
                          e.preventDefault();
                          if (totalDebit === totalCredit && totalDebit > 0) {
                            toast.success("Balanced ✔");
                            setTimeout(
                              () => narrationRef.current?.focus(),
                              100,
                            );
                          } else moveToNextRow(index);
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          fontSize: "0.83rem",
                          background:
                            row.type !== "Dr"
                              ? "#fafafa"
                              : activeCell.row === index &&
                                  activeCell.field === "debit"
                                ? "rgba(16,185,129,0.1)"
                                : "#f8fafc",
                          "& fieldset": { borderColor: "#e5e9ef" },
                          "&:hover fieldset": {
                            borderColor:
                              row.type === "Dr" ? "#10b981" : "#e5e9ef",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#10b981",
                            borderWidth: "1.5px",
                          },
                          "&.Mui-disabled": { background: "#fafafa" },
                        },
                      }}
                    />
                  </TableCell>

                  {/* ── Credit ── */}
                  <TableCell align="right" sx={{ width: "17%" }}>
                    <TextField
                      size="small"
                      fullWidth
                      disabled={row.type !== "Cr"}
                      value={row.credit}
                      inputRef={(el) => {
                        if (!rowRefs.current[index])
                          rowRefs.current[index] = {};
                        rowRefs.current[index].credit = el;
                      }}
                      inputProps={{
                        style: {
                          textAlign: "right",
                          fontFamily: "monospace",
                          fontWeight: 600,
                        },
                      }}
                      onFocus={() => {
                        setActiveRowIndex(index);
                        setActiveCell({ row: index, field: "credit" });
                      }}
                      onChange={(e) => {
                        const u = [...rows];
                        u[index].credit = e.target.value;
                        u[index].debit = "";
                        setRows(u);
                      }}
                      onKeyDown={(e) => {
                        handleDeleteShortcut(e, index);
                        handleArrowNavigation(e, index, "credit");
                        if (e.key === "Enter") {
                          e.preventDefault();
                          const currentRow = rows[index];
                          if (
                            voucherType === "Receipt" &&
                            currentRow?.type === "Cr" &&
                            currentRow?.account?.toLowerCase() ===
                              "accounts receivable" &&
                            currentRow?.credit
                          ) {
                            setBillRowIndex(index);
                            setOpenBillAdjustment(true);
                            return;
                          }
                          if (totalDebit === totalCredit && totalDebit > 0) {
                            toast.success("Balanced ✔");
                            setTimeout(
                              () => narrationRef.current?.focus(),
                              100,
                            );
                          } else moveToNextRow(index);
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          fontSize: "0.83rem",
                          background:
                            row.type !== "Cr"
                              ? "#fafafa"
                              : activeCell.row === index &&
                                  activeCell.field === "credit"
                                ? "rgba(239,68,68,0.08)"
                                : "#f8fafc",
                          "& fieldset": { borderColor: "#e5e9ef" },
                          "&:hover fieldset": {
                            borderColor:
                              row.type === "Cr" ? "#ef4444" : "#e5e9ef",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ef4444",
                            borderWidth: "1.5px",
                          },
                          "&.Mui-disabled": { background: "#fafafa" },
                        },
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "50% 16% 17% 17%",
          alignItems: "center",
          px: 2,
          py: 1.2,

          /* 🔥 Premium background */
          background:
            totalDebit === totalCredit
              ? "linear-gradient(135deg, rgba(16,185,129,0.08), rgba(34,197,94,0.06))"
              : "linear-gradient(135deg, rgba(220,38,38,0.08), rgba(239,68,68,0.06))",

          border: "1px solid #e5e9ef",
          borderTop: "none",
          borderRadius: "0 0 12px 12px",

          boxShadow: "0 4px 12px rgba(10,31,68,0.05)",
        }}
      >
        {/* EMPTY SPACE */}
        <Box />

        {/* 🔥 TOTAL LABEL */}
        <Typography
          sx={{
            fontSize: "0.8rem",
            fontWeight: 700,
            color: "#64748b",
            letterSpacing: "0.3px",
          }}
        >
          Total
        </Typography>

        {/* 🔥 DEBIT */}
        <Typography
          sx={{
            fontSize: "0.9rem",
            fontWeight: 800,
            textAlign: "right",
            fontFamily: "monospace",
            color: totalDebit === totalCredit ? "#059669" : "#dc2626",
          }}
        >
          ₹ {totalDebit.toLocaleString()}
        </Typography>

        {/* 🔥 CREDIT */}
        <Box sx={{ textAlign: "right" }}>
          <Typography
            sx={{
              fontSize: "0.9rem",
              fontWeight: 800,
              fontFamily: "monospace",
              color: totalDebit === totalCredit ? "#059669" : "#dc2626",
            }}
          >
            ₹ {totalCredit.toLocaleString()}
          </Typography>

          {/* 🔥 DIFFERENCE */}
          {totalDebit !== totalCredit && (
            <Typography
              sx={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#dc2626",
                mt: 0.3,
              }}
            >
              Diff ₹ {Math.abs(totalDebit - totalCredit).toLocaleString()}
            </Typography>
          )}
        </Box>
      </Box>

      {isBalanced && (
        <Box
          sx={{
            mt: 2,
            p: 2,
            background: "#fff",
            borderRadius: 1,
            border: "1px solid #e2e8f0",
            transition: "all 0.3s ease",
          }}
        >
          <TextField
            fullWidth
            multiline
            rows={2}
            label="Narration"
            inputRef={narrationRef}
            value={narration}
            onChange={(e) => setNarration(e.target.value)}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "ArrowUp") {
                e.preventDefault();

                const lastRowIndex = rows.length - 1;

                setTimeout(() => {
                  rowRefs.current[lastRowIndex]?.drcr?.focus();
                }, 50);
              }
            }}
          />
        </Box>
      )}

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#f9fafb", // Tailwind gray-50
          borderTop: "1px solid #e5e7eb", // Tailwind gray-200
          boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.05)",
          zIndex: 100,
          paddingLeft: { xs: "0px", sm: "245px" },
          overflowX: { xs: "auto", md: "visible" }, // ✅ Enable scroll on small screens
          whiteSpace: "nowrap", // ✅ Prevent wrapping
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            minWidth: "900px",
          }}
        >
          <Button
            ref={saveBtnRef}
            variant="contained"
            color="success"
            startIcon={<SaveIcon />}
            sx={{ borderRadius: 0 }}
            onClick={voucherGroupId ? handleUpdateVoucher : handleSaveVoucher}
          >
            {voucherGroupId
              ? "Update Voucher / Ctrl+S"
              : "Save Voucher / Ctrl+S"}
          </Button>
        </Box>
      </Box>

      <AccountCreateDialog
        open={openAccountDialog}
        onClose={() => setOpenAccountDialog(false)}
        setGroups={setGroups}
        groups={groups}
        onAccountCreated={handleAccountCreated}
      />

      <BillAdjustment
        open={openBillAdjustment}
        onClose={() => setOpenBillAdjustment(false)}
        creditAmount={rows[billRowIndex]?.credit || 0}
        existingData={rows[billRowIndex]?.billAllocation || []}
        onApply={(billData) => {
          if (billRowIndex === null) return;

          const updated = [...rows];

          // 🔥 SAVE BILL ADJUSTMENT DATA
          updated[billRowIndex].billAllocation = billData;

          setRows(updated);

          // 👉 move focus to next row
          setTimeout(() => {
            moveToNextRow(billRowIndex);
          }, 100);
        }}
      />
    </Box>
  );
};

export default ManualVouchers;

const vLabelStyle = {
  fontSize: "0.65rem",
  fontWeight: 600,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.3px",
  mb: 0.5,
};

const vFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#f8fafc",
    fontSize: "0.875rem",
    "& fieldset": { borderColor: "#e5e9ef" },
    "&:hover fieldset": { borderColor: "#2a54a6" },
    "&.Mui-focused fieldset": {
      borderColor: "#b93acf",
      borderWidth: "1.5px",
    },
    "&.Mui-focused": { background: "#ffffff" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#b93acf" },
};
